import React, { useMemo } from 'react';
import { priceToReadable } from 'utils/Helpers';
import { PAYMENT_STATES, PAYMENT_TYPES } from 'utils/Constants';

import Pill from 'components/Misc/Pill';
import { Title } from 'components/Misc/Typography';
import { Datepicker } from 'components/Misc/Form';

const Payment = ({ payment }) => {
	// Store additional information
	const type = useMemo(() => PAYMENT_TYPES.find(type => type.value === payment.type), [payment]);
	const state = useMemo(() => PAYMENT_STATES.find(state => state.value === payment.state), [payment]);

	return (
		<div className="py-3 px-4 flex flex-col space-y-2 md:flex-row md:items-center md:space-y-0 md:space-x-2 rounded-lg bg-white dark:bg-neutral-800 transition-all">
			<Title
				title={type?.text}
				className="flex-1"
			/>

			<div className="flex space-x-2">
				<Pill
					name={priceToReadable(payment.amount)}
				/>

				<Pill
					name={state?.text}
					theme={state?.theme}
				/>

				<Datepicker
					readOnly
					value={payment.deadlineAt}
				/>
			</div>
		</div>
	);
};

export default Payment;